import type { Op } from 'quill/core';

export const deltaToText = (ops: Op[]) => {
  if (!ops || !Array.isArray(ops)) {
    return null;
  }

  return ops
    .flatMap((op) => (op && typeof op.insert === 'string' ? [op.insert] : []))
    .join('')
    .trimEnd();
};

export const textToDelta = (text: string) => {
  if (typeof text !== 'string') return [];
  return [{ insert: text.endsWith('\n') ? text : `${text}\n` }];
};
